import ImageWithDefault from 'components/ImageWithDefault/ImageWithDefault';
import ArrivalDelay from 'src/views/practitioner/components/ArrivalDelay';


export default {
  ArrivalDelay,
  ImageWithDefault,
};